import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { ArrowUpRight } from "lucide-react";

const FAQS = [
  {
    q: "How does Ege Models work?",
    a: "We scout, develop and represent talent from our office in Rotterdam, and place them on editorial, runway and campaign work — directly with clients and through established partner agencies abroad. Our job is to discover faces, build their book, and steward their careers from the first test shoot onwards.",
  },
  {
    q: "What kind of talent are you looking for?",
    a: "Faces with character. We represent women and value range, presence, and a willingness to be developed — over a particular look or background.",
  },
  {
    q: "Can I apply if I'm under 18?",
    a: "Yes — but applicants under 18 must apply with explicit consent from a parent or legal guardian, and any contracts will be signed by them. Please email info@egemodels.com for guidance before submitting.",
  },
  {
    q: "Do I need professional photos to apply?",
    a: "No — please submit unedited natural-light digitals: headshot straight on, headshot in profile, full-length straight on, full-length in profile. No makeup, no filters, no retouching. Plain background, fitted tank top and jeans. We want the canvas.",
  },
  {
    q: "How long does it take to hear back about an application?",
    a: "Our scouts review every application individually. If your profile aligns with our roster we'll be in touch within 14 days. You can also check the status of your application using your reference code on the status page.",
  },
  {
    q: "How do I know a scout or message is really from Ege Models?",
    a: "Every genuine approach from Ege Models is confirmed by an email from info@egemodels.com. We never ask for payment, and we never request nude or undergarment photos. If someone claims to scout for us and you have not received that email, do not engage — write to info@egemodels.com and we will confirm whether it is us.",
  },
  {
    q: "I run an international agency — how do I partner with you?",
    a: "Write to info@egemodels.com with a short note about your agency, the markets you cover and the kind of talent you're interested in. We'd love to talk.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="pt-32">
      <section className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <p className="label-overline text-zinc-500">Frequently asked</p>
        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl tracking-tighter font-light mt-6 leading-[0.9]">
          Questions<span className="italic text-zinc-600">.</span>
        </h1>
        <p className="text-zinc-700 mt-8 max-w-2xl text-lg leading-relaxed">
          Everything you might want to know about Ege Models, our roster,
          and how to work with us.
        </p>

        <div className="mt-16 border-t border-black/15">
          <Accordion type="single" collapsible className="divide-y divide-black/10">
            {FAQS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-0">
                <AccordionTrigger className="font-serif text-xl md:text-2xl py-6 text-left tracking-tight hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-700 leading-relaxed pb-8 text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-20 border-t border-black/10 pt-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <p className="label-overline text-zinc-500">Didn't find your answer?</p>
            <h3 className="font-serif text-3xl mt-3">Reach the studio.</h3>
          </div>
          <div className="flex gap-3">
            <Link to="/contact" className="btn-primary">Contact <ArrowUpRight size={16}/></Link>
            <Link to="/apply" className="btn-ghost">Get Scouted</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
